import * as tslib_1 from "tslib";
import { setMailboxMessageConfiguration } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveMarkAsReadOption')(function saveMarkAsReadOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceObject;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceObject = {};
                    if (optionState.behavior !== null) {
                        userOptions.PreviewMarkAsRead = optionState.behavior;
                        // This conversion is required because UserOptions deal with string literals (MarkAsRead type),
                        // whereas MailboxMessageConfigurationOptions deals with numbers (PreviewMarkAsReadBehavior const enum type)
                        switch (state.optionState.behavior) {
                            case 'Delayed':
                                serviceObject.PreviewMarkAsReadBehavior = 0 /* Delayed */;
                                break;
                            case 'OnSelectionChange':
                                serviceObject.PreviewMarkAsReadBehavior =
                                    1 /* OnSelectionChange */;
                                break;
                            case 'Never':
                                serviceObject.PreviewMarkAsReadBehavior = 2 /* Never */;
                                break;
                        }
                    }
                    if (optionState.delay !== null) {
                        userOptions.MarkAsReadDelaytime = optionState.delay;
                        serviceObject.PreviewMarkAsReadDelaytime = optionState.delay;
                    }
                    return [4 /*yield*/, setMailboxMessageConfiguration(serviceObject)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveMarkAsReadOption.js.map